import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a7011c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Employees" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_employees_actions = _resolveComponent("employees-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_employees_filters = _resolveComponent("employees-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_employees_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createEmployee,
          onUpdate: _ctx.updateEmployee,
          onDelete: _ctx.deleteEmployee
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Сотрудники" }),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить сотрудника ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_employees_filters, {
        class: "mt-6",
        loading: _ctx.data_state.employees.is_loading,
        onSearch: _ctx.applyFilters,
        onReset: _ctx.resetFilters
      }, null, 8, ["loading", "onSearch", "onReset"]),
      _createElementVNode("div", _hoisted_3, [
        (
                    _ctx.data_state.employees.is_failed &&
                    !_ctx.data_state.employees.failure.error_state.is_cancel
                )
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.data_state.employees.is_loading,
              text: "При получении списка сотрудников произошла ошибка",
              "error-message": _ctx.data_state.employees.failure.error_state.message,
              "error-url": _ctx.data_state.employees.failure.error_state.url,
              "error-status": _ctx.data_state.employees.failure.error_state.status,
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadEmployees(_ctx.data_state.employees.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.data_state.employees.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.data_state.employees.is_loading,
                  columns: _ctx.EmployeesColumns,
                  rows: _ctx.data_state.employees.list,
                  pagination: "",
                  "pagination-current-page": _ctx.data_state.employees.pagination.current_page,
                  "pagination-limit": _ctx.data_state.employees.pagination.limit,
                  "pagination-total-items": _ctx.data_state.employees.pagination.total_items,
                  "pagination-total-pages": _ctx.data_state.employees.pagination.total_pages,
                  onChangePage: _ctx.loadEmployees
                }, {
                  td: _withCtx(({ row, column }) => [
                    (column.key === 'status' && row.status)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(row.status.description), 1)
                        ], 64))
                      : (_ctx.isRowObj(row[column.key], column.key))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.getRowObj(row[column.key])), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                          ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_4, [
                      (
                                    _ctx.havePermissions([
                                        'cabinet-employee-update',
                                        'all-root-permission',
                                    ])
                                )
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            class: "extra-small yellow mr-3",
                            hint: "Редактировать",
                            onClick: ($event: any) => (_ctx.startUpdate(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (
                                    _ctx.havePermissions([
                                        'cabinet-employee-destroy',
                                        'all-root-permission',
                                    ])
                                )
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 1,
                            class: "red small",
                            hint: "Удалить сотрудника",
                            onClick: ($event: any) => (_ctx.startDelete(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}